// removed by extract-text-webpack-plugin
module.exports = {"theme":"#1890ff"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 7